module.exports = __webpack_public_path__ + "static/media/CSS3_logo_and_wordmark.7415a70a.svg";